var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor zoho-create-record" }, [
    _vm.hasNonZohoChannels
      ? _c("div", { staticClass: "integration-warning" }, [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c(
          "section",
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.zohoModuleName")) + "e"),
            ]),
            _vm._v(" "),
            _c("CustomPicker", {
              attrs: {
                items: _vm.modules,
                idKey: "api_name",
                labelKey: "plural_label",
                title: _vm.$t("message.selectModule"),
              },
              model: {
                value: _vm.selectedModule,
                callback: function ($$v) {
                  _vm.selectedModule = $$v
                },
                expression: "selectedModule",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("section", [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.standardFields"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field-picker-wrapper" },
            [
              _c("CustomPicker", {
                attrs: {
                  items: _vm.availableStandardFields,
                  idKey: "api_name",
                  labelKey: "field_label",
                  title: "Select Standard Field",
                },
                model: {
                  value: _vm.selectedStandardField,
                  callback: function ($$v) {
                    _vm.selectedStandardField = $$v
                  },
                  expression: "selectedStandardField",
                },
              }),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addField(_vm.selectedStandardField)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Add Field")]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("section", [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.customFields"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field-picker-wrapper" },
            [
              _c("CustomPicker", {
                attrs: {
                  items: _vm.availableCustomFields,
                  idKey: "api_name",
                  labelKey: "field_label",
                  title: _vm.$t("message.selectCustomFields"),
                },
                model: {
                  value: _vm.selectedCustomField,
                  callback: function ($$v) {
                    _vm.selectedCustomField = $$v
                  },
                  expression: "selectedCustomField",
                },
              }),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addField(_vm.selectedCustomField)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Add Field")]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.clone.fields, function (field, fieldApiName) {
          return _c(
            "section",
            { key: fieldApiName, staticClass: "field-section" },
            [
              !field.fieldMeta.system_mandatory
                ? _c(
                    "i",
                    {
                      staticClass: "material-icons remove-field-icon",
                      attrs: { title: "Alanı Kaldır" },
                      on: {
                        click: function ($event) {
                          return _vm.removeField(fieldApiName)
                        },
                      },
                    },
                    [_vm._v("\n                close\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(field.fieldMeta.field_label)),
              ]),
              _vm._v(" "),
              fieldApiName === "Owner"
                ? _c("CustomPicker", {
                    attrs: {
                      items: _vm.zohoUsers,
                      idKey: "id",
                      labelKey: "name",
                      title: field.fieldMeta.field_label,
                    },
                    model: {
                      value: field.value,
                      callback: function ($$v) {
                        _vm.$set(field, "value", $$v)
                      },
                      expression: "field.value",
                    },
                  })
                : field.fieldMeta.data_type !== "picklist"
                ? _c(
                    "div",
                    { staticClass: "text-editor-wrapper" },
                    [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: field.fieldMeta.field_label,
                          "show-attributes": true,
                          "show-emoji": false,
                        },
                        model: {
                          value: field.value,
                          callback: function ($$v) {
                            _vm.$set(field, "value", $$v)
                          },
                          expression: "field.value",
                        },
                      }),
                    ],
                    1
                  )
                : _c("CustomPicker", {
                    attrs: {
                      items: field.fieldMeta.pick_list_values,
                      idKey: "actual_value",
                      labelKey: "display_value",
                      title: field.fieldMeta.field_label,
                    },
                    model: {
                      value: field.value,
                      callback: function ($$v) {
                        _vm.$set(field, "value", $$v)
                      },
                      expression: "field.value",
                    },
                  }),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warning-content" }, [
      _c("span", { staticClass: "material-icons warning-icon" }, [
        _vm._v("warning"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "warning-text" }, [
        _c("strong", [_vm._v("Entegrasyon Uyarısı")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Listede Zoho olmayan kanallar bulunmaktadır. Lütfen bu kanalları entegre edin."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }